module.exports = __webpack_public_path__ + "static/media/verticalRectangle_tomato.55216947.svg";